module.exports = __webpack_public_path__ + "img/send_fax_bg.1f7a5d5b.jpg";